<template>
	<div>
		<div>
			<!-- <Tag
        v-for="item in count"
        :key="item"
        :name="item"
        closable
        @on-close="handleClose2"
      >标签{{ item + 1 }}</Tag>
      <Input search enter-button placeholder="Enter something..."/>
      <Button icon="ios-add" type="dashed" size="small" @click="handleAdd">添加条件</Button>-->
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">按条件查询</Button>
			<Button type="primary" style="margin-left: 5px" @click="showDown = true">数据下发</Button>
		</div>

		<div>
			<Modal title="Title" v-model="showDown" :mask-closable="false" width="800">
				<p slot="header" style="color:#0066FF;text-align:center">
					<span>数据下发</span>
				</p>
				<div style="text-align:center">
					<Steps :current="currentDownStep" size="small">
						<Step title="选择设备"></Step>
						<Step title="填写参数"></Step>
						<!-- <Step title="确认下发"></Step> -->
					</Steps>
					<Divider></Divider>
					<div v-if="currentDownStep == 0">
						<Row>
							<Col span="6">
							<Select transfer filterable v-model="selectedValve">
								<Option v-for="item in valvesNo" :value="item.valveBaseMac" :key="item.valveBaseMac">
									{{ item.valveBaseNumber }}
								</Option>
							</Select>
							</Col>
							<Col span="6">
							<Button type="primary" @click="selectValve">添加至列表</Button>
							</Col>
						</Row>
						<Divider></Divider>
						<Row>
							<Tag v-for="item in selectValveArray" style="left:0" type="border" closable color="primary"
								@on-close="handleClose(item)">{{item}}</Tag>
						</Row>
					</div>
					<div v-if="currentDownStep == 1">
						<div class="layout">
							<Layout>
								<Layout>
									<Content :style="{background: '#fff'}">
										<Layout>
											<Sider hide-trigger :style="{background: '#fff'}" class="param-menu">
												<Menu active-name="1-2" theme="light" width="auto"
													@on-select="gotoContent">
													<MenuItem v-for="(profile, profileName) in valveProfile['paramSet']"
														:name="profileName">{{profile.cn}} </MenuItem>
												</Menu>
											</Sider>
											<Content :style="{'padding-left': '10px', background: '#fff'}"
												v-if="currentProfileName != ''">
												<Row>
													<Col span="8">
													<Select transfer filterable v-model="selectedDownValve">
														<Option v-for="item in selectValveArray" :value="item"
															:key="item">{{ valvesEnum[item] }}</Option>
													</Select>
													</Col>
													<Col span="8">
													<Button type="primary"
														@click="reloadDown(currentProfileName)">载入历史下发数据</Button>
													</Col>
													<Col span="8">
													<Button type="primary"
														@click="nextStep(currentProfileName)">下发</Button>
													</Col>
												</Row>
												<Divider></Divider>
												<div class="param-content">
													<v-row
														v-for="(value, key) in valveProfile['paramSet'][currentProfileName].params"
														:key="key" class="mx-4 my-2">
														<span style="width: 100%;text-align: left">
															<!-- 这个地方是遍历json-->
															<span
																:name="value.cn == undefined?((profile[key] != undefined && profile[key].cn != undefined)?profile[key].cn:key):value.cn"
																style="width: 50%; display: inline-block;">{{ (value.cn == undefined?((profile[key] != undefined && profile[key].cn != undefined)?profile[key].cn:key):value.cn)}}<br />({{key}})</span>

															<InputNumber v-if="value.type == 'Number'"
																style="width: 32%;" :active-change="false"
																v-model="paramSet[currentProfileName][key]"
																:min="value.min? (value.min - 0.01):undefined"
																:max="value.max? (value.max + 0.01):undefined">
															</InputNumber>
															<Input style="width: 32%;" v-if="value.type != 'Number'"
																v-model="paramSet[currentProfileName][key]" />
															<!-- <label v-if="value.unit"
																style="margin-right: -41px;padding-left: 10px; width: 8%; display: inline-block;">{{ value.unit }}</label> -->

															<label v-if="key=='powerMax'">
																<input type="radio" name="power" :value="powerMaxUnit"
																	@click="clickUnit(1)"
																	checked /><label>{{ value.unit }}</label>
																<input type="radio" name="power" :value="powerMaxUnit"
																	@click="clickUnit(2)" /><label>L</label>
															</label>
															<lable v-else>
																<label v-if="value.unit"
																	style="margin-right: -41px;padding-left: 10px; width: 8%; display: inline-block;">{{ value.unit }}</label>
															</lable>
														</span>
													</v-row>
												</div>
											</Content>
										</Layout>
									</Content>
								</Layout>
							</Layout>
						</div>
					</div>
				</div>
				<div slot="footer">
					<Button v-show="currentDownStep > 0" type="info" size="large" @click="preStep">上一步</Button>
					<Button v-show="currentDownStep < 1" type="info" size="large" @click="nextStep">下一步</Button>
				</div>
			</Modal>
		</div>

		<!-- 模态框 -->
		<div>
			<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
				<p slot="header" style="color:#0066FF;text-align:center">
					<Icon type="md-create" />
					<span>按条件检索</span>
				</p>
				<div style="text-align:center">
					<CheckboxGroup v-model="selectedCondition" class="check_grop">
						<!-- <div>
              <Checkbox label="saveId">
                <span>存储编号</span>
              </Checkbox>
              <Input v-model="saveIdModel" placeholder="请输入存储编号" style="width: 150px" />
            </div>-->
						<div>
							<Checkbox label="deviceId">
								<span>设备编号</span>
							</Checkbox>
							<Input v-model="deviceIdModel" placeholder="请输入设备编号" style="width: 150px" />
						</div>
						<div>
							<Checkbox label="mainType">
								<span>主命令字&nbsp;&nbsp;&nbsp;</span>
							</Checkbox>
							<Select v-model="mainTypeModel" style="width:150px" placeholder="请选择命令字">
								<Option v-for="(value, key) in valveProfile" v-if="value == 'paramSet'" :value="key"
									:key="key">{{key}}</Option>
							</Select>
						</div>
						<div>
							<Checkbox label="subType">
								<span>子命令字&nbsp;&nbsp;&nbsp;</span>
							</Checkbox>
							<Select v-model="subTypeModel" :disabled="mainTypeModel == undefined || mainTypeModel == ''"
								style="width:150px" placeholder="请选择命令字">
								<Option v-for="(value, key) in valveProfile[mainTypeModel]" :value="key" :key="key">
									{{value.cn}}
								</Option>
							</Select>
						</div>
						<div>
							<Checkbox label="timeStamp">
								<span>时间区间</span>
							</Checkbox>
							<Tooltip transfer placement="top"
								:disabled="timeStampModel == undefined || timeStampModel[0] == ''">
								<div slot="content">
									<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[0])}}</span>
									<br />
									<span style="margin-left:50%">~</span>
									<br />
									<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[1])}}</span>
								</div>
								<DatePicker v-model="timeStampModel" type="daterange" split-panels placeholder="请选择时间区间"
									style="width: 150px"></DatePicker>
							</Tooltip>
						</div>
					</CheckboxGroup>
				</div>
				<div slot="footer">
					<Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
				</div>
			</Modal>
		</div>
		<br />
		<Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" shape="circle" icon="ios-apps" @click="showData(row, index)"></Button>
			</template>
			<template slot-scope="{ row, index }" slot="status">
				<!-- <Button type="primary" size="small" style="margin-right: 5px" @click="updateDownMessage(row)">下发</Button> -->

				<!-- <Button
                  v-if="
                    row.messageDirection == 'down' && row.messageRemark1 == -10
                  "
                  type="primary"
                  size="small"
                  style="margin-right: 5px;"
                  @click="updateDownMessage(row)"
                  >下发</Button
        >-->
				<label v-if="
                    row.messageMaintype != 'paramSet'">已存储</label>
				<label v-if="
                    row.messageMaintype == 'paramSet' && row.messageState == 0
                  ">待下发</label>
				<label v-if="
                    row.messageMaintype == 'paramSet' && row.messageState == 1
                  ">已下发待响应</label>
				<label v-if="
                    row.messageMaintype == 'paramSet' && row.messageState == 2
                  ">下发完成</label>
				<label v-if="
                    row.messageMaintype == 'paramSet' && row.messageState == -100
                  ">下发失败</label>
				<!-- <label
                  v-if="
                    row.messageDirection == 'down' && row.messageRemark1 == -11
                  "
                  >取消下发</label
        >-->
			</template>
		</Table>
		<br />
		<Page :current="pageNo" :total="pageTotal" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />
	</div>
</template>

<script>
	import {
		constants
	} from "crypto";
	export default {
		name: "valve_upinstructions_2",
		mounted() {
			// this.tableHeight =
			//   window.innerHeight - this.$refs.table.$el.offsetTop - 160;
			this.request();
		},
		created() {
			this.getValveProfile();
			this.getValvesNo();
			// this.getValveDownProfile();
		},
		methods: {
			clickUnit(value) {
				this.powerMaxUnit = value;
			},
			gotoContent(name, params) {
				this.currentProfileName = name;
			},
			reloadDown(type) {
				if (this.selectedDownValve == "" || this.selectedDownValve == undefined) {
					this.$Notice.error({
						title: "异常",
						desc: "请选择载入设备号"
					});
					return;
				}
				let that = this;
				this.pageNo = 1;
				$.ajax({
					url: "/api/valve/getLastDownValve",
					contentType: "application/json",
					type: "post",
					data: JSON.stringify({
						messageMac: that.selectedDownValve,
						messageMaintype: "paramSet",
						messageSubtype: type
					}),
					dataType: "json",
					success: function(data) {
						if (data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}
						let body = data.body;
						if (body.length == 0) {
							that.reloadMessage[type] =
								"无历史下发" + type + "类型数据故无法载入";
						} else {
							let lastDown = body[0];
							console.log(lastDown);
							let timestamp = global.dateFtt(
								"yyyy-MM-dd hh:mm:ss",
								new Date(lastDown.messageReceivetimestamp)
							);
							let downContent = JSON.parse(lastDown.messageContent);
							console.log(downContent);
							Object.keys(downContent).forEach(function(key) {
								that.paramSet[type][key] = downContent[key];
							});
							that.reloadMessage[type] =
								"已载入" + timestamp + "下发的" + type + "数据";
							that.$forceUpdate();
						}
						that.$Notice.info({
							title: "提示",
							desc: that.reloadMessage[type]
						});
						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						// that.$Notice.error({
						// 	title: "异常",
						// 	desc: "接口请求异常"
						// });
					}
				});
			},
			preStep() {
				this.currentDownStep = this.currentDownStep - 1;
			},
			nextStep(type) {
				let that = this;
				if (that.currentDownStep == 0) {
					if (that.selectValveArray.length == 0) {
						that.$Notice.info({
							title: "提示",
							desc: "请至少添加一个设备"
						});
					} else {
						that.currentDownStep = that.currentDownStep + 1;
						Object.keys(that.reloadMessage).forEach(function(key) {
							that.reloadMessage[key] = "";
						});
					}
				} else if (that.currentDownStep == 1) {
					console.log("--------------" + type);
					that.$Modal.confirm({
						title: "操作确认",
						content: "确认进行下发操作？",
						onOk: () => {
							that.downMessage(type);
							that.currentDownStep = 0;
							that.showDown = false;
							Object.keys(that.valveProfile.paramSet).forEach(function(
								profileName
							) {
								let profile = that.valveProfile.paramSet[profileName].params;
								let temp = {};
								Object.keys(profile).forEach(function(key) {
									temp[key] = profile[key].default ? profile[key].default :
										profile[key].min;
								});
								that.paramSet[profileName] = temp;
								that.reloadMessage[profileName] = "";
							});
						},
						onCancel: () => {}
					});
				}
			},
			handleClose(item) {
				this.selectValveArray.pop(item);
			},
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			request() {
				if (localStorage.getItem("isAdmin") != "true") {
					this.requestBody["valveBaseRemark6"] = localStorage.getItem(
						"personnelGroverningBodyId"
					);
					console.log(this.requestBody);
				}
				this.requestBody.messageMaintype = "paramSet";
				let that = this;
				this.pageNo = 1;
				$.ajax({
					url: "/api/mp/getMessageDetail?page=" +
						that.pageNo +
						"&pageAmount=" +
						that.pageSize +
						"&paging=true",
					contentType: "application/json",
					type: "post",
					data: JSON.stringify(that.requestBody),
					dataType: "json",
					success: function(data) {
						// if (data.errorCode != 0) {
						//   that.$Notice.error({
						//     title: "异常",
						//     desc: data.errorInfo
						//   });
						//   return;
						// }
						that.$Notice.success({
							title: "提示",
							desc: "查询上传指令数据成功"
						});
						that.data1 = data.resultList;
						that.pageTotal = data.amount;
						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
				// this.$axios({
				//   method: "post",
				//   url: "/api/selectInstructions",
				//   headers: { "Content-Type": "text/json" },
				//   data: JSON.stringify({ name: 1, pwd: 2 }),
				//   transformRequest: [
				//     function(data) {
				//       // console.log(JSON.stringify(data))
				//       // console.log(qs.stringify(data))
				//       // console.log(qs.stringify(JSON.stringify(data)))
				//       console.log(data);
				//       this.data1 = data;
				//     }
				//   ]
				// });
			},

			ok() {},
			cancel() {},
			del() {},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			// 修改
			getValvesNo() {
				let url = "/api/mp/getValveBaseInfos";
				if (localStorage.getItem("isAdmin") != "true") {
					url =
						url +
						"?valveBaseRemark6=" +
						localStorage.getItem("personnelGroverningBodyId") + "&valveBaseRemark2=WIFI";
				} else {
					url =
						url +
						"?valveBaseRemark6=&valveBaseRemark2=WIFI";
				}
				let that = this;
				that.loading = true;
				$.ajax({
					url: url,
					contentType: "application/json",
					type: "get",
					dataType: "json",
					success: function(data) {
						that.valvesNo = data;
						let valvesEnum = {};
						for (let i = 0; i < data.length; i++) {
							let temp = data[i];

							valvesEnum[temp.valveBaseMac] = temp.valveBaseNumber;
						}
						that.valvesEnum = valvesEnum;
						console.log(valvesEnum);
					},
					error: function(textStatus) {
						// that.$Notice.error({
						// 	title: "异常",
						// 	desc: "接口请求异常"
						// });
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 修改
			changePage(index) {
				if (localStorage.getItem("isAdmin") != "true") {
					this.requestBody["valveBaseRemark6"] = localStorage.getItem(
						"personnelGroverningBodyId"
					);
					console.log(this.requestBody);
				}
				this.pageNo = index;
				let that = this;
				that.loading = true;
				// this.pageNo = 1;
				$.ajax({
					url: "/api/mp/getMessageDetail?page=" +
						that.pageNo +
						"&pageAmount=" +
						that.pageSize +
						"&paging=true",
					contentType: "application/json",
					type: "post",
					data: JSON.stringify(that.requestBody),
					dataType: "json",
					success: function(data) {
						console.log(data);
						that.data1 = data.resultList;
						that.pageTotal = data.amount;
						that.loading = false;

						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				this.requestBody.messageMaintype = "paramSet";
				for (let temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "mainType") {
						if (this.mainTypeModel == "") {
							continue;
						}

						this.requestBody["messageMaintype"] = this.mainTypeModel;
					}
					if (this.selectedCondition[temp] == "subType") {
						if (this.subTypeModel == "") {
							continue;
						}

						this.requestBody["messageSubtype"] = this.subTypeModel;
					}
					if (this.selectedCondition[temp] == "deviceId") {
						if (this.deviceIdModel == "") {
							continue;
						}

						this.requestBody["valveBaseNumber"] = this.deviceIdModel;
						// requestBody.set("deviceId", this.deviceIdModel);
					}
					// if (this.selectedCondition[temp] == "saveId") {
					//   if (this.saveIdModel == "") {
					//     continue;
					//   }

					//   this.requestBody["saveId"] = this.saveIdModel;
					//   // requestBody.set("saveId", this.saveIdModel);
					// }
					if (this.selectedCondition[temp] == "timeStamp") {
						this.requestBody["startDate"] = this.timeStampModel[0];
						this.requestBody["endDate"] = this.timeStampModel[1];
					}
				}
				if (localStorage.getItem("isAdmin") != "true") {
					this.requestBody["valveBaseRemark6"] = localStorage.getItem(
						"personnelGroverningBodyId"
					);
					console.log(this.requestBody);
				}
				// 调用接口查询
				let that = this;
				that.loading = true;
				this.modal8 = false;
				this.pageNo = 1;
				$.ajax({
					url: "/api/mp/getMessageDetail?page=" +
						that.pageNo +
						"&pageAmount=" +
						that.pageSize +
						"&paging=true",
					contentType: "application/json",
					type: "post",
					data: JSON.stringify(that.requestBody),
					dataType: "json",
					success: function(data) {
						console.log(data);

						that.$Notice.success({
							title: "提示",
							desc: "查询上传指令数据成功"
						});
						that.data1 = data.resultList;
						that.pageTotal = data.amount;
						that.loading = false;

						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
			},
			selectValve() {
				if (this.selectValveArray.indexOf(this.selectedValve) > -1) {
					this.$Notice.info({
						title: "提示",
						desc: "请勿重复添加"
					});
				} else {
					this.selectValveArray.push(this.selectedValve);
				}
			},
			getValveDownProfile() {
				// 调用接口查询
				let that = this;
				that.loading = true;
				$.ajax({
					url: "/api/valve/getSafetyValveDownProfile",
					contentType: "application/json",
					type: "get",
					dataType: "json",
					success: function(data) {
						console.log(data);
						if (data.errorCode == 0) {
							that.valveDownProfile = data.body;
							Object.keys(that.valveDownProfile).forEach(function(profileName) {
								let profile = that.valveDownProfile[profileName];
								let temp = {};
								Object.keys(profile).forEach(function(key) {
									temp[key] = profile[key].default;
								});
								that.paramSet[profileName] = temp;
								that.reloadMessage[profileName] = "";
							});
							//   that.loading = false;
						} else {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
						}

						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
			},
			downMessage(type) {
				let that = this;
				let downParams = {};
				let params = that.valveProfile.paramSet[type].params;
				Object.keys(params).forEach(function(key) {
					let value = that.paramSet[type][key];
					if (value == null) {
						if (params[key].type == 'Number') {
							if (params[key].default) {
								value = params[key].default;
							} else if (params[key].min) {
								value = params[key].min;
							} else {
								value = 1;
							}
						}
					}
					if (key == "powerMax") {
						//判断选择的单位是kw还是L，如果是L的是话，就要转换成kw存储
						if (that.powerMaxUnit == 2) {
							value = value * 2;
						}
					}
					downParams[key] = value.toString();
				});

				$.ajax({
					url: "/api/valve/downValveMessage",
					contentType: "application/json",
					type: "post",
					dataType: "json",
					data: JSON.stringify({
						messageNoArray: that.selectValveArray,
						messageContent: JSON.stringify(downParams),
						messageMaintype: "paramSet",
						messageSubtype: type,
						messageState: "0"
					}),
					success: function(data) {
						console.log(data);
						if (data.errorCode != 0) {
							that.$Notice.warning({
								title: "提示",
								desc: data.errorInfo
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "下发成功等待设备获取"
						});
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					},
					complete: function() {
						that.loading = false;
						that.request();
					}
				});
			},
			getValveProfile() {
				// 调用接口查询
				let that = this;
				that.loading = true;
				$.ajax({
					url: "/api/valve/getValveProfile",
					contentType: "application/json",
					type: "get",
					dataType: "json",
					success: function(data) {
						console.log(data);
						if (data.errorCode == 0) {
							console.log(data.body);
							that.valveProfile = data.body;
							Object.keys(that.valveProfile.paramSet).forEach(function(
								profileName
							) {
								let profile = that.valveProfile.paramSet[profileName].params;
								let temp = {};
								Object.keys(profile).forEach(function(key) {
									temp[key] = profile[key].default;
								});
								that.paramSet[profileName] = temp;
								that.reloadMessage[profileName] = "";
							});
							that.loading = false;
						} else {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
						}

						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			},
			handleClose2(event, name) {
				const index = this.count.indexOf(name);
				this.count.splice(index, 1);
			},
			convertData(data, type, enums) {
				let result = data;
				console.log(data);

				if ("Time" == type) {
					result = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(data * 1000));
				} else if ("Enum" == type) {
					result = enums[data] == undefined ? data : enums[data];
				}

				console.log(result);
				return result;
			},
			// 点击事件：点击显示数据集
			showData(row, index) {
				// 遍历数据集拼接HTML
				let htmlStr = "";
				let _this = this;

				let mainType = row.messageMaintype;
				let subType = row.messageSubtype;
				console.log(_this.valveProfile);

				try {
					htmlStr =
						"<table style='border:1px solid #C0C0C0; text-align: center;width: 100%; table-layout:fixed;'>";
					let amount = 0;
					let dataObject = JSON.parse(row.messageContent);
					let data;
					data = dataObject;
					Object.keys(data).forEach(function(key) {
						if (amount % 2 == 0) {
							htmlStr += "<tr >";
						}
						htmlStr +=
							"<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
							(_this.valveProfile[mainType] == undefined ||
								_this.valveProfile[mainType][subType] == undefined ||
								_this.valveProfile[mainType][subType]["params"][key] == null ?
								key :
								_this.valveProfile[mainType][subType]["params"][key].cn) +
							"</td><td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
							_this.convertData(
								data[key],
								_this.valveProfile[mainType][subType]["params"][key] == undefined ?
								"" :
								_this.valveProfile[mainType][subType]["params"][key].type,
								_this.valveProfile[mainType][subType]["params"][key] == undefined ?
								"" :
								_this.valveProfile[mainType][subType]["params"][key].enum
							) +
							(_this.valveProfile[mainType] == undefined ||
								_this.valveProfile[mainType][subType] == undefined ?
								"" :
								" " +
								(_this.valveProfile[mainType][subType]["params"][key] ==
									undefined ?
									"" :
									_this.valveProfile[mainType][subType]["params"][key]
									.unit)) +
							"</td>";
						if (amount % 2 == 1) {
							htmlStr += "</tr>";
						}
						amount++;
					});

					htmlStr += "</table>";
					_this.selectDataHtml = htmlStr;
					_this.selectData = data;
				} catch (err) {
					console.log(err);
					_this.selectDataHtml = "<div>JSON格式错误</div>";
					_this.selectData = row.messageContent;
					htmlStr = _this.selectDataHtml;
				}
				// this.showDrawer = true;

				let that = this;
				this.$Notice.open({
					title: "存储编号:" + row.messageId + "\t设备编号:" + row.messageMac,
					// desc: htmlStr,
					render: h => {
						return h("div", {
							on: {},
							style: {
								height: "100%",
								width: "100%"
							},
							domProps: {
								innerHTML: htmlStr
							}
						});
					},
					duration: 20
				});
			}
		},
		data() {
			let that = this;
			return {
				valveProfile: {},
				valveDownProfile: {},
				columns1: [{
						title: "设备编号",
						key: "valveBaseNumber",
						align: "center",
						sortable: true
					},
					{
						title: "设备Mac",
						key: "messageMac",
						align: "center",
						sortable: true
					},
					{
						title: "消息类型",
						align: "center",
						sortable: true,
						render: function(h, params) {
							let text = '';
							let mainType = that.valveProfile[params.row.mainType];
							if (mainType[params.row.subType]) {
								text = mainType[params.row.subType].cn;
							} else {
								text = mainType.cn;
							}
							return h(
								"div",
								text
							);
						}
					},
					{
						title: "日期",
						sortable: true,
						align: "center",
						render: function(h, params) {
							try {
								// if (params.row.messageHappentimestamp != undefined) {
								//   let timeStr = global.dateFtt(
								//     "yyyy-MM-dd hh:mm:ss",
								//     new Date(params.row.messageHappentimestamp)
								//   );
								//   return h("div", timeStr == "" ? "设备未校时" : timeStr);
								// } else {
								return h(
									"div",
									global.dateFtt(
										"yyyy-MM-dd hh:mm:ss",
										new Date(params.row.messageHappentimestamp)
									)
								);
								// }
							} catch (err) {
								return h("div", "JSON格式错误");
							}
						}
					},
					{
						title: "保存日期",
						sortable: true,
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.messageReceivetimestamp)
								)
							);
						}
					},
					{
						title: "状态",
						slot: "status",
						align: "center"
					},
					{
						title: "数据集",
						slot: "action",
						align: "center",
						width: 80
					}
				],
				reloadMessage: {},
				data1: [],
				loading: true,
				showDrawer: false,
				selectDataHtml: "",
				selectData: {},
				modal8: false,
				pageTotal: 0,
				pageSize: 30,
				selectedCondition: [],
				valvesEnum: {},
				saveIdModel: "",
				deviceIdModel: "",
				mainTypeModel: "",
				subTypeModel: "",
				commandIdModel: "",
				timeStampModel: "",
				pageNo: 1,
				requestBody: {},
				showDown: false,
				currentDownStep: 0,
				valvesNo: [],
				selectedValve: "",
				selectValveArray: [],
				paramSet: {},
				selectedDownValve: "",
				currentProfileName: "",
				powerMaxUnit: 1, //最大功率的时候，出现的单位单选按钮的默认值
			};
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}

	.ivu-modal {
		top: 20px;
	}

	.ivu-layout-sider::-webkit-scrollbar {
		width: 0;
	}

	.param-menu {
		height: 370px;
		overflow-y: scroll;
	}

	.param-menu::-webkit-scrollbar {
		width: 5px;
	}

	.param-menu::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: lightgray;
	}

	.param-menu::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
	}

	.param-content {
		height: 280px;
		overflow-y: scroll;
	}

	.param-content::-webkit-scrollbar {
		width: 5px;
	}

	.param-content::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: lightgray;
	}

	.param-content::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
	}
</style>
